import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './data-gathering-placeholder.scss';

applyTranslations(require('./data-gathering-placeholder.i18n.json'));

export const DataGatheringPlaceholder = () => (
  <section className="data-gathering-placeholder">
    <div className="data-gathering-placeholder__inner">
      <SVGDynamicIcon
        name="two-gears-custom-fg"
        customColor="grey"
        width={75}
        height={75}
      />
      <div className="data-gathering-placeholder__label">
        {__t('data_gathering_placeholder.content')}
      </div>
    </div>
  </section>
);
